import React from "react";
import { Link } from "react-router-dom"; //Link
import "../layout/Home/Home.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../caregiver/nursingcare/NursingCare.css";

import doctorbanner from "../assets/images/doctorbanner.png";
import cardiology from "../assets/images/cardiology.png";
import offer1 from "../assets/images/offer1.png";
import docimg from "../assets/images/docimg.png";

import Blog from '../layout/Home/Blog';
import Midbanner from '../layout/Home/Midbanner';
import Faq from '../layout/Home/Faq';

const category = [
  {
    id: 1,
    title: "Cardiology",
    iconimage: cardiology,
  },
  {
    id: 2,
    title: "Urology",
    iconimage: cardiology,
  },
  {
    id: 3,
    title: "Neurology",
    iconimage: cardiology,
  },
  {
    id: 4,
    title: "Orthopaedics",
    iconimage: cardiology,
  },
  {
    id: 5,
    title: "Psychiatry",
    iconimage: cardiology,
  },
  {
    id: 6,
    title: "Paediatrics",
    iconimage: cardiology,
  },
  {
    id: 7,
    title: "Endocrinology",
    iconimage: cardiology,
  },
  {
    id: 8,
    title: "Dentist",
    iconimage: cardiology,
  },
  {
    id: 9,
    title: "Pulmonologists",
    iconimage: cardiology,
  },
  {
    id: 10,
    title: "General Physician",
    iconimage: cardiology,
  },
  {
    id: 11,
    title: "Dermatology",
    iconimage: cardiology,
  },
  {
    id: 12,
    title: "Nephrology",
    iconimage: cardiology,
  },
];

function BrowseSpecialties() {
  return (
    <>
    <Header/>
      {/* <section>
        <div className="container-fluid">
          <div className="doctor-banner">
            <img src={doctorbanner} alt="" className="img-fluid" />
          </div>
        </div>
      </section> */}

      <section className="speciality_main">
        <div className="container-fluid">
          <div className="dr_pg_heading_section">
              <div className="row">
                  <div className=" col-xl-6 col-lg-7 col-md-7 col-12">
                    <h2 className="dr_pg_heading">Choose Your Medical Speciality</h2>
                    <p className="dr_pg_pera">Connect with experienced healthcare professionals across multiple specialities</p>
                  </div>
                  <div className=" col-xl-6 col-lg-5 col-md-5 col-12">
                    <div className="search_sec_long">
                        <form>
                            <input type="text"  placeholder="Search Service...."  className="search_input_long" />
                            <button type="submit" className="search_btn_long"> SEARCH </button>
                        </form>
                    </div>
                  </div>
              </div>
          </div> 

          <div className="speciality-outer">
            <div className="row g-3">
              {category.map((item) => (
                <div className="col-lg-2 col-md-2 col-sm-6 col-6">
                   <Link to="/doctor-consultation-services">
                    <div className="speciality-box">
                      <img src={item.iconimage} alt="" className="img-fluid" />
                      <h3>{item.title}</h3>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>

          <div className="row">
            <div className="col-lg-5 col-md-5 col-sm-12 col-12">
              <div className="page-title">
                <h2>Offers</h2>
                <p>
                  Connect with experienced healthcare professionals across
                  multiple specialities
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="offer-boxes">
                <div className="lft_part">
                  <label>CaresAtHome</label>
                  <h3>Download the App & Get ₹200 HealthCash</h3>
                  <button>Download App</button>
                </div>
                <div className="rgt_part">
                  <img src={offer1} alt="" className="img-fluid" />
                </div>
              </div>
            </div>
             <div className="col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="offer-boxes second-box">
                <div className="lft_part">
                  <label>CaresAtHome</label>
                  <h3>Consult with Specialists at just ₹199</h3>
                  <button>Consult Now</button>
                </div>
                <div className="rgt_part">
                  <img src={docimg} alt="" className="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer/>
    </>
  );
}

export default BrowseSpecialties;
